import React, { useEffect } from 'react'

const useLockBodyScroll = state => {
  useEffect(() => {
    document.body.style.overflow = state ? 'hidden' : 'unset'
  }, [state])
}

export default useLockBodyScroll
